/**
 * 테마 식별자의 정본은 UX 원칙 문서의 디자인 토큰 절이다.
 * 스타일시트의 테마 블록과 이 목록이 같은 이름을 쓴다.
 */
export const THEME_IDS = ['light', 'dark', 'dusk'] as const

export type ThemeId = (typeof THEME_IDS)[number]

/** 문서 루트에 값이 없으면 라이트로 보이므로 기본값도 라이트다. */
export const DEFAULT_THEME: ThemeId = 'light'

/* 테마 라벨은 사전이 갖는다. 화면 언어를 따르는 문구이고 값의 정체는 이 식별자가 지킨다. */

export interface ThemePreference {
  themeId: ThemeId
}

export function isThemeId(value: unknown): value is ThemeId {
  return typeof value === 'string' && (THEME_IDS as readonly string[]).includes(value)
}
